import {AnyAction} from 'redux';
import {SET_CHANNEL, SET_CHANNELS_SEARCH} from '../actionTypes';
import {Channel, ChannelAPIResponse} from 'stream-chat';

export interface ChannelState {
  currentChannel?: Channel;
  currentWatchChannel?: ChannelAPIResponse;
  channelSearch?: Channel[];
}

const initialState: ChannelState = {
  currentChannel: undefined,
  currentWatchChannel: undefined,
  channelSearch: [],
};

const channel = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_CHANNELS_SEARCH:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CHANNEL:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default channel;
